import React from 'react';
import { BriefcaseIcon, FileTextIcon, MailIcon } from 'lucide-react';
interface AboutMeProps {
  setActiveTab: (tab: string) => void;
}
export function AboutMe({
  setActiveTab
}: AboutMeProps) {
  const companies = [{
    name: 'Bluebonnet Data',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/if6QUWSrqNuUKzQgkFMEvm/BLUEBONNET_DATA_LOGO_%28Vertical%29_-_Blue_Filled_In%281%29.png'
  }, {
    name: 'Rhode Island Democratic Party',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3m1dE7Toa2Quvhs642NYkr/225px-Rhode_Island_Democratic_Party.jpg'
  }, {
    name: 'DigiDems',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sJfPydoCiQqQQ7MiA6xzkn/abzPhhCkJK91Bll4lTUiQDl6TqoPe9AJHQNxJIMRZ7w.png'
  }, {
    name: 'Susan Wild for Congress',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2XbURhnghkhQ7s9a5EMLqV/wild-congress.jpg'
  }, {
    name: 'Santa Fe Institute',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mwjzpqoUiyhVG3FFWJ8dMw/sfi.png'
  }];
  const pastClients = [{
    name: 'Change Agent',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8qZWHAAX8FZvh2N3etHCef/CA-cropped-LOGO-NEW.png'
  }, {
    name: 'AGAVE Democratic Infrastructure Fund',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f7RAFofT6WQfHiukvcWsPB/Agave.png'
  }, {
    name: 'VoteRev',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qFWfAGvVeg4ydHigEFBnSL/VoteRev-Logo-Mark-Blue_%281%29.png'
  }, {
    name: 'MeckDems',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vh9BJ2UafJYdrPPSzXrriX/meckdemslogo.png'
  }, {
    name: 'Kentucky Civic Engagement Table',
    logo: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6ao1Qj26b6rXhodE4no5rS/KCET.png'
  }];
  return <div className="w-full max-w-4xl mx-auto px-6 py-12" data-id="element-40">
      <div className="flex flex-col items-center gap-8 mb-12" data-id="element-41">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/o9MKoMQK1h7YbRzo1RrzTq/JakeJackson_Headshot_%283%29.jpg" alt="Jake Jackson" className="w-48 h-48 rounded-full object-cover shadow-lg" data-id="element-42" />
        <div className="flex-1 text-center" data-id="element-43">
          <h2 className="text-4xl font-bold text-gray-900 mb-2" data-id="element-44">
            Jake Jackson
          </h2>
          <h3 className="text-xl text-blue-600 font-semibold mb-4" data-id="element-45">
            Political Data & Technology Specialist
          </h3>
          <p className="text-gray-700 leading-relaxed" style={{
          marginBottom: '1rem'
        }} data-id="element-46">
            I've worked in progressive political data & technology for five
            years in roles ranging from Data Director to Executive Director, and
            have extensive experience working for hundreds of political clients
            through Bluebonnet Data on a wide variety of political data
            analytics and engineering projects, as well as some personal
            freelance consulting. I'm a technical generalist with deep
            experience in Python and SQL for data management and analytics, and
            experience in data engineering, backend software engineering, and
            data science.
          </p>
          <p className="text-gray-700 leading-relaxed mb-6" data-id="element-47">
            I am seeking freelance consulting work or full-time roles for
            progressive movement organizations, campaigns, and companies. I can
            contribute in a technical leadership role, or in an individual
            contributor role as a data analyst, data engineer, software
            engineer, or related roles.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-48">
            <button onClick={() => setActiveTab('portfolio')} className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors font-medium" data-id="element-49">
              <BriefcaseIcon size={20} data-id="element-50" />
              See Some of My Work
            </button>
            <button onClick={() => setActiveTab('resume')} className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-gray-800 transition-colors font-medium" data-id="element-51">
              <FileTextIcon size={20} data-id="element-52" />
              Find My Resume
            </button>
            <button onClick={() => setActiveTab('contact')} className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-blue-600 text-white rounded-md hover:bg-green-700 transition-colors font-medium" data-id="element-53">
              <MailIcon size={20} data-id="element-54" />
              Get In Touch
            </button>
          </div>
        </div>
      </div>
      <div className="border-t pt-8" data-id="element-55">
        <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-56">
          Organizations I Have Worked For
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center justify-items-center mb-12" data-id="element-57">
          {companies.map((company, index) => <div key={index} className="w-full flex items-center justify-center bg-white p-8 rounded-lg shadow-md" data-id="element-58">
              <img src={company.logo} alt={company.name} className="max-h-48 max-w-full object-contain" data-id="element-59" />
            </div>)}
        </div>
        <div className="border-t pt-8" data-id="element-60">
          <h3 className="text-2xl font-bold text-gray-900 mb-2 text-center" data-id="element-61">
            Past Clients
          </h3>
          <p className="text-gray-600 text-center mb-6" data-id="element-62">
            either personal clients or a small subset of clients I worked
            closely with while at Bluebonnet Data
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-center justify-items-center" data-id="element-63">
            {pastClients.map((client, index) => <div key={index} className="w-full flex items-center justify-center bg-white p-8 rounded-lg shadow-md" data-id="element-64">
                <img src={client.logo} alt={client.name} className="max-h-48 max-w-full object-contain" data-id="element-65" />
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}